<template>
  <div :class="{'nav-open': $sidebar.showSidebar}">
    <!-- <notifications transition-name="notification-list" transition-mode="out-in">
    </notifications> -->
      <transition name="fade"
                mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
  // Loading some plugin css asynchronously
  import swal from 'sweetalert2'

  export default {
    mounted () {
      window.addEventListener('online', this.notificationInternetStatus)
      window.addEventListener('offline', this.notificationInternetStatus)
    },
    methods: {
      notificationInternetStatus () {
        if (window.navigator.onLine) {
          swal({
            title: 'Internet!',
            text: 'Conectado.',
            type: 'success',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false,
            allowOutsideClick: false,
            preConfirm: () => {
              return (new Promise((resolve, reject) => {
                resolve('OK')
              }))
            }
          })
        } else {
          swal({
            title: 'Internet!',
            text: 'Desconectado. Verifique sua conexão com a internet.',
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false,
            allowOutsideClick: false
          })
        }
      }
    },
    computed: {
      currentUser () {
        return this.$store.getters.currentUser
      }
    }
  }
</script>
<style lang="scss">
  .notifications.vue-notifyjs {
    .notification-list-move {
      transition: transform 0.3s, opacity 0.4s;
    }
    .notification-list-item {
      display: inline-block;
      margin-right: 10px;

    }
    .notification-list-enter-active, .notification-list-leave-active {
      transition: opacity 0.4s;
    }
    .notification-list-enter, .notification-list-leave-to /* .list-leave-active for <2.1.8 */
    {
      opacity: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue